import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import './App.css';
import FAQSearch from './components/mainPage/FAQSearch';
import { lazy, Suspense } from 'react';
import Callback from './components/zoom/callback'; // Adjust path if needed
import GrainyBackground from './components/gradientAura/Grainybackground';
import { SERVICE_ROUTE_CONFIGS } from './config';

// Staff-only pages load on demand so kiosk / QR visitors don't download dashboard code
const StaffDashboardPage = lazy(() => import('./components/mainPage/StaffDashboardPage'));
const AdminDashboardPage = lazy(() => import('./components/mainPage/AdminDashboardPage'));

const VALID_ROUTE_KEYS = new Set(SERVICE_ROUTE_CONFIGS.map((r) => r.routeKey));

const LibraryRoute = () => {
  const { library } = useParams();
  if (!VALID_ROUTE_KEYS.has(String(library || '').toLowerCase())) {
    return <Navigate to="/" replace />;
  }
  return (
    <div className="app-root">
      <GrainyBackground className="grainy-bg" />
      <FAQSearch />
    </div>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/dashboard"
          element={
            <div className="app-root app-root--scrollable">
              <GrainyBackground className="grainy-bg" />
              <Suspense fallback={null}>
                <StaffDashboardPage />
              </Suspense>
            </div>
          }
        />
        <Route
          path="/dashboard/admin"
          element={
            <div className="app-root app-root--scrollable">
              <GrainyBackground className="grainy-bg" />
              <Suspense fallback={null}>
                <AdminDashboardPage />
              </Suspense>
            </div>
          }
        />
        <Route
          path="/"
          element={
            <div className="app-root">
              <GrainyBackground className="grainy-bg" />
              <FAQSearch />
            </div>
          }
        />
        <Route path="/:library" element={<LibraryRoute />} />
      </Routes>
    </Router>
  );
}

export default App;